import { gsap } from "@gsap";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

/**
 * Layout: Ervaringen slider
 * Slug: ervaringen_slider
 */

// Scale per distance from the active slide (design: 280 / 203 / 145 px)
const SCALES = [1, 203 / 280, 145 / 280];
const SHAPE_ROTATION = 40;

const initErvaringenSlider = () => {
    document.querySelectorAll(".ervaringen_slider-layout").forEach((layout) => {
        const textEl = layout.querySelector(".text-swiper");
        const imageEl = layout.querySelector(".image-swiper");
        if (!textEl || !imageEl) return;

        const images = imageEl.querySelectorAll(".swiper-slide");
        const total = images.length;
        const shape = layout.querySelector(".image-col > svg");
        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        const imageSwiper = new Swiper(imageEl, {
            allowTouchMove: false,
            virtualTranslate: true,
            watchSlidesProgress: true,
        });

        const place = (active, animate) => {
            images.forEach((image, i) => {
                const distance = (i - active + total) % total;
                const scale = SCALES[distance] ?? 0;
                const props = { scale, opacity: scale ? 1 : 0, zIndex: SCALES.length - distance };

                if (animate && !reduceMotion) {
                    gsap.to(image, { ...props, duration: 0.9, ease: "power3.inOut", overwrite: true });
                } else {
                    gsap.set(image, props);
                }
            });
        };

        const rotateShape = (direction) => {
            if (!shape || reduceMotion) return;
            gsap.to(shape, {
                rotation: `+=${SHAPE_ROTATION * direction}`,
                transformOrigin: "50% 50%",
                duration: 1.2,
                ease: "power3.inOut",
                overwrite: "auto",
            });
        };

        const textSwiper = new Swiper(textEl, {
            effect: "fade",
            fadeEffect: { mode: 'out-in', },
            speed: 600,
            rewind: true,
            autoHeight: false,
            allowTouchMove: total > 1,
            navigation: {
                prevEl: layout.querySelector(".arrow-prev"),
                nextEl: layout.querySelector(".arrow-next"),
            },
            controller: { control: imageSwiper },
            on: {
                init: (swiper) => place(swiper.activeIndex, false),
                slideChange: (swiper) => {
                    place(swiper.activeIndex, true);
                    rotateShape(swiper.activeIndex >= swiper.previousIndex ? 1 : -1);
                },
            },
        });

        place(textSwiper.activeIndex, false);
    });
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initErvaringenSlider);
} else {
    initErvaringenSlider();
}
